import cn from 'classnames'
import React from 'react'
import { ReactSVG } from 'react-svg'


const WizardXpButton = ({
  label,
  subtext,
  iconUrl,
  imageUrl,
  active,
  onClick,
  className,
}) => {
  return (
    <button
      className={cn('wizard-xp-button', {
        'wizard-xp-button--active': active,
        [className]: className,
        })}
      onClick={onClick}
    >
      <div className="wizard-xp-button__border" />
      {iconUrl && (
        <ReactSVG
          className="wizard-xp-button__icon"
          src={iconUrl}
        />
      )}
      {imageUrl && <div className="wizard-xp-button__image" style={{ backgroundImage: `url(${imageUrl})`}} />}
      <div className="wizard-xp-button__text-wrap">
        <span className="wizard-xp-button__label">{label}</span>
        {subtext && <span className="wizard-xp-button__subtext">{subtext}</span>}
      </div>
    </button>
  )
}

export default WizardXpButton
